$(document).ready(function () {
  //testimonial section
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1000,
    //autoplay:false,
    autoplay: {
      delay: 2000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next.next-btn",
      prevEl: ".swiper-button-prev.prev-btn",
    },
  });
});
/*hover section js start*/
document.addEventListener("DOMContentLoaded", function () {
  var middleTitles = document.querySelectorAll(".middle-title");
  if (middleTitles.length > 0) {
    middleTitles[0].classList.add("active");
    var firstSetId = middleTitles[0].getAttribute("data-id");
    document.querySelectorAll(".change-images").forEach(function (imgElement) {
      var imgId = imgElement.getAttribute("id");
      imgElement.style.display = firstSetId === imgId ? "block" : "none";
    });
  }
  //hover section js
  middleTitles.forEach(function (element) {
    element.addEventListener("click", function () {
      var set_1 = this.getAttribute("data-id");
      middleTitles.forEach(function (el) {
        el.classList.remove("active");
      });
      this.classList.add("active");
      document
        .querySelectorAll(".change-images")
        .forEach(function (imgElement) {
          var set_2 = imgElement.getAttribute("id");
          imgElement.style.display = set_1 === set_2 ? "block" : "none";
        });
    });
  });
});
/*hover section js end*/
/*scrolltop js start*/
let mybutton = document.getElementById("myBtn");
window.onscroll = function () {
  scrollFunction();
};
function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}
function topFunction() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}
/*scrolltop js end*/

document.addEventListener("DOMContentLoaded", function () {
  const showMoreLink = document.querySelector(".show-more-link");
  const showMoreImages = document.querySelector(".show-more-images");

  if (showMoreLink && showMoreImages) {
    showMoreLink.addEventListener("click", function () {
      showMoreImages.classList.toggle("hide");
      showMoreLink.textContent = showMoreImages.classList.contains("hide")
        ? "Show More"
        : "Show Less";
    });
  }

  //mega menu hover
  let items = document.querySelectorAll(".mega-menu");
  let currentItemIndex;
  items.forEach((item, itemIndex) => {
    const content = item.querySelector(".mega-menu__content");

    item.addEventListener("mouseover", () => {
      // Close other open mega menus
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
      ) {
        items[currentItemIndex].removeAttribute("open");
      }

      currentItemIndex = itemIndex;
      item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", () => {
      let close = true;
      content.addEventListener("mouseover", () => {
        close = false;
      });
      setTimeout(() => {
        if (close) item.removeAttribute("open");
      }, 1000);
    });

    content.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});
